import * as ReactDOM from 'react-dom/client';

import * as Sentry from '@sentry/browser';
import App from './App';
import 'moment/dist/locale/pt-br';

import { Environment } from '@cobliteam/react-environments';

import './index.css';
import '@cobliteam/ui/theme/index.css';

const appVersion = process.env.REACT_APP_VERSION || 'development';
const env = Environment.getInstance().getEnvironment();

// Avoiding localhost/npm run serve errors on Sentry
if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.name,
    release: appVersion,
  });
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(<App />);
